{
  "appointment-card": {
    "buttons": {
      "details": "Podrobnosti na"
    },
    "text": {
      "and-more": "a {{nr}} více",
      "cancelled": "ZRUŠENO",
      "minutes": "minuty"
    }
  }
}
